module.exports = __webpack_public_path__ + "static/media/blue-horizonta.6e63a760.png";